import React, { useCallback, useEffect, useRef, useState } from "react";
import Select from "react-select";
import { Bars, Circles } from "react-loader-spinner";
import nodata from "../../Assets/Image/admin/nodata.png";
import user from "../../Assets/Image/admin/user.png";
import view from "../../Assets/Image/admin/view.png";
import deletes from "../../Assets/Image/admin/delete.png";
import add from "../../Assets/Image/admin/add.png";
import { useNavigate } from "react-router-dom";
import Dialog from "../../Base-Component/Dialog/Dialog";
import { CirclePlus, CircleX, Upload } from "lucide-react";
import close from "../../Assets/Image/admin/close.png";
import edit from "../../Assets/Image/admin/edit.png";
import {
  addQuiz,
  deleteQuiz,
  getCategoryList,
  getQuizList,
  listSubcategory,
  updateQuiz,
} from "../../Services/ApiServices";
import toast from "react-hot-toast";
import Cookies from "js-cookie";
import { IMG_URL, LIST_LANGUAGES_API } from "../../Services/Api";
import noImage from "../../Assets/Image/admin/user.png";
import "suneditor/dist/css/suneditor.min.css";
import SunEditor from "suneditor-react";
import DOMPurify from "dompurify";
import PropTypes from "prop-types";
import axios from "axios";
import Cropper from "react-easy-crop";

function Quiz() {
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const imageRef = useRef(null);

  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isModalOpens, setModalOpens] = useState(false);
  const [isAddQuiz, setIsAddQuiz] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [cropModal, setCropModal] = useState(false);
  const [cropImg, setCropImg] = useState(false);

  const [selectStatus, setSelectStatus] = useState(null);
  const [totalPage, setTotalPage] = useState("");
  const [image, setImage] = useState("");
  const [img, setImg] = useState("");
  const [quizId, setQuizId] = useState("");
  const [isIndex, setIsIndex] = useState("");
  const [languageName, setLanguageName] = useState("");
  const [descriptionData, setDescriptionData] = useState("");

  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [pageNo, setPageNo] = useState(1);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [imageType, setImageType] = useState(1);

  const [formValue, setFormValue] = useState({});
  const [newImge, setNewImge] = useState({});

  const [categoryData, setCategoryData] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [quizData, setQuizData] = useState([]);
  const [listLanguages, setListLanguages] = useState([]);
  const [thumbnails, setThumbnails] = useState([]);

  const handleCategoryList = () => {
    getCategoryList()
      .then((res) => {
        const data = res.data.data;
        setCategoryData(data);
        const option = data?.map((item) => ({
          label: (
            <div className="flex items-center p-1 uppercase">
              <img
                src={
                  item.category_image ? IMG_URL + item.category_image : noImage
                }
                className="w-14 h-14 rounded-md object-cover mr-2"
              />
              {item.category_name || ""}
            </div>
          ),
          value: item.id,
          id: item.category_name,
        }));

        if (option?.length > 0) {
          setSelectedOption(option[0]);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };

  const handleLanguages = () => {
    axios
      .get(LIST_LANGUAGES_API)
      .then((res) => {
        const data = res.data.islanguage;
        setListLanguages(data);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err.response.data.message);
        }
      });
  };

  const handleSubCategoryList = (id) => {
    let obj = {
      category_id: id,
      language_id: selectStatus.value,
    };
    listSubcategory(obj)
      .then((res) => {
        const data = res.data.data;
        setSubCategoryData(data);
      })
      .catch((err) => {
        handleError(err);
      });
  };

  const handleQuizList = (subCategoryId) => {
    setLoader(true);
    let obj = {
      subCategory_id: subCategoryId,
      page: pageNo,
    };
    getQuizList(obj)
      .then((res) => {
        const data = res.data.data;
        setQuizData(data);
        setTotalPage(res.data.totalPages);
        setLoader(false);
      })
      .catch((err) => {
        handleError(err);
      });
  };

  const handleError = (err) => {
    if (err?.response?.status === 401) {
      Cookies.remove("e_learning_token");
      navigate("/login");
    } else {
      toast.error(err?.response?.data?.message);
    }
    setLoader(false);
  };

  useEffect(() => {
    handleCategoryList();
    handleLanguages();
  }, []);

  useEffect(() => {
    if (selectStatus && selectedOption) {
      handleSubCategoryList(selectedOption.value);
    }
  }, [selectStatus, selectedOption]);

  useEffect(() => {
    if (selectedOptions) {
      handleQuizList(selectedOptions.id);
    }
  }, [selectedOptions, pageNo]);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "50px",
      height: "50px",
      border: "none",
      outline: "0px",
      boxShadow: "none",
      "&:hover": {
        border: "none",
      },
      "&:focus": {
        border: "none",
        boxShadow: "none",
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: "50px",
      padding: "0 8px",
      border: "0px",
      outline: "0px",
    }),
    input: (provided) => ({
      ...provided,
      margin: "0",
      padding: "0",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "50px",
      border: "0px",
      outline: "0px",
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "white" : "black",
      cursor: "pointer",
      backgroundColor: state.isSelected
        ? "#e29c2995"
        : state.isFocused
        ? "#e29c2940"
        : "white",
      ":active": {
        backgroundColor: "#e29c2910",
        color: "white",
      },
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = "opacity 300ms";
      return {
        ...provided,
        opacity,
        transition,
        display: "flex",
        alignItems: "center",
      };
    },
  };

  const startDragging = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
    document.body.style.userSelect = "none";
  };

  const stopDragging = () => {
    setIsDragging(false);
    document.body.style.userSelect = "";
  };

  const onDragging = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  const renderPaginationButtonss = () => {
    const maxPagesToShow = 3;
    const buttons = [];
    const startPage = Math.max(1, pageNo - Math.floor(maxPagesToShow / 2));
    const endPage = Math.min(totalPage, startPage + maxPagesToShow - 1);

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={
            i === pageNo
              ? "px-4 py-[7px] mx-1 bg-[#EA5F5F1A] rounded-md text-[#EA5F5F]"
              : "px-4 py-[7px] mx-1 text-[#EA5F5F]"
          }
        >
          {i}
        </button>
      );
    }
    return buttons;
  };

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPage) {
      setPageNo(page);
    }
  };

  const handleDetails = (id) => {
    navigate("/quiz/question/" + id.id);
  };

  const handleFile = (e) => {
    setImage(e.target.files[0]);
    handleFiles(e.target.files[0]);
    let imageData = URL.createObjectURL(e.target.files[0]);
    setImg(imageData);
  };

  const handleFiles = async (images) => {
    const thumbnailss = [];
    // for (let i = 0; i < images.length; i++) {
    const file = images;
    if (file?.type?.includes("video") && file?.type === "video/mp4") {
      setImageType(2);
      try {
        const thumbnail = await generateThumbnailFromVideo(file);
        let videoFile = base64ToFile(thumbnail, "thumbnail.jpg", "image/jpeg");
        thumbnailss.push(videoFile);
        setThumbnails(thumbnailss);
      } catch (error) {
        console.error("Error generating thumbnail:", error);
      }
    } else {
      setThumbnails([]);
      setImageType(1);
    }
    // }
  };

  const generateThumbnailFromVideo = (videoFile) => {
    return new Promise((resolve, reject) => {
      const video = document.createElement("video");
      video.preload = "metadata";
      video.crossOrigin = "anonymous";

      video.onloadedmetadata = () => {
        try {
          const duration = video.duration;
          if (isNaN(duration) || duration === Infinity) {
            throw new Error("Invalid video duration");
          }
          const middleTime = duration / 2;
          video.currentTime = middleTime;
        } catch (error) {
          reject(new Error(`Error in onloadedmetadata`));
        }
      };

      video.onseeked = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          const context = canvas.getContext("2d");
          if (context) {
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const thumbnailData = canvas.toDataURL("image/jpeg");
            resolve(thumbnailData);
          } else {
            throw new Error("Canvas context is null");
          }
        } catch (error) {
          reject(new Error(`Error in onseeked`));
        }
      };

      video.onerror = (error) => {
        console.error("Video error event:", error);
        reject(new Error("Error loading or seeking video."));
      };

      video.src = URL.createObjectURL(videoFile);
    });
  };

  const base64ToFile = (base64String, filename, mimeType) => {
    const base64Content = base64String.split(",")[1];
    const byteCharacters = atob(base64Content);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });
    const file = new File([blob], filename, { type: mimeType });
    return file;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (isUpdate) {
      const types = image?.type?.includes("video") ? "video" : "image";
      const formData = new FormData();
      formData.append("quiz_id", formValue.id);
      formData.append("title", formValue.title);
      formData.append("subtitle", formValue.sub_title);
      formData.append("reward_point", formValue.reward_point);
      if (descriptionData) {
        formData.append("description", descriptionData);
      }
      formData.append("sub_category_id", formValue.sub_category_id);
      if (image) {
        formData.append("quiz_image", image);
        formData.append("media_type", types);
      }
      if (thumbnails.length) {
        formData.append("thumbnail", thumbnails[0]);
      }
      if (!descriptionData) {
        toast.error("Please enter description");
        setIsLoading(false);
      } else {
        updateQuiz(formData)
          .then((res) => {
            toast.success(res.data.message);
            setIsAddQuiz(false);
            handleQuizList(selectedOptions.id);
            setImg("");
            setImage("");
            setThumbnails([]);
          })
          .catch((err) => {
            if (err.response.status == 401) {
              Cookies.remove("e_learning_token");
              navigate("/login");
            } else {
              toast.error(err.response.data.message);
            }
            setIsLoading(false);
          });
      }
    } else {
      const types = image.type.includes("video") ? "video" : "image";
      const formData = new FormData();
      formData.append("title", formValue.title);
      formData.append("subtitle", formValue.sub_title);
      formData.append("description", descriptionData);
      formData.append("sub_category_id", formValue.sub_category_id);
      formData.append("reward_point", formValue.reward_point);
      if (image) {
        formData.append("quiz_image", image);
        formData.append("media_type", types);
      }
      if (thumbnails.length) {
        formData.append("thumbnail", thumbnails[0]);
      }
      if (!image) {
        toast.error("Please Select Image");
      } else if (!descriptionData) {
        toast.error("Please enter description");
        setIsLoading(false);
      } else {
        addQuiz(formData)
          .then((res) => {
            toast.success(res.data.message);
            setIsAddQuiz(false);
            handleQuizList(selectedOptions.id);
            setImg("");
            setImage("");
            setThumbnails([]);
          })
          .catch((err) => {
            if (err.response.status == 401) {
              Cookies.remove("e_learning_token");
              navigate("/login");
            } else {
              toast.error(err.response.data.message);
            }
            setIsLoading(false);
          });
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formValue, [name]: value });

    console.log("language >>", formValue.sub_category_id);

    if (formValue.sub_category_id) {
      for (let i = 0; i < subCategoryData.length; i++) {
        if (formValue.sub_category_id == subCategoryData[i].id) {
          setLanguageName(subCategoryData[i]?.Language?.Language_name);
        }
      }
    }
  };

  const handleDelete = (e) => {
    e.preventDefault();
    setIsLoading(true);

    let obj = {
      quiz_id: quizId,
    };
    deleteQuiz(obj)
      .then((res) => {
        toast.success(res.data.message);
        setIsDelete(false);
        const data = [...quizData];
        data.splice(isIndex, 1);
        setQuizData(data);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err.response.data.message);
        }
        setIsLoading(false);
      });
  };

  const handleEdit = (data) => {
    setIsUpdate(true);
    setFormValue(data);
    setDescriptionData(data.description);
    setIsAddQuiz(true);
    setIsLoading(false);
    setImage("");
    setImg("");
  };

  const handleView = (data) => {
    setFormValue(data);
    setModalOpens(true);
    setIsLoading(false);
  };

  const HtmlContent = ({ htmlString }) => {
    const sanitizedHtml = DOMPurify.sanitize(htmlString);
    const style = `
      ol {
        margin: 0;
        padding: 0;
        list-style-type: decimal; /* Numbering */
        padding-left: 20px; /* Adjust left padding as needed */
      }
      ul {
        margin: 0;
        padding: 0;
        list-style-type: disc; /* Bullets */
        padding-left: 20px; /* Adjust left padding as needed */
      }
      li {
        margin: 0;
        padding: 0;
        line-height: 1.5;
      }
      a {
        color: blue;
      }
    `;

    return (
      <div
        dangerouslySetInnerHTML={{
          __html: `<style>${style}</style>${sanitizedHtml}`,
        }}
      />
    );
  };

  HtmlContent.propTypes = {
    htmlString: PropTypes.string.isRequired,
  };

  const handleAdd = () => {
    if (selectStatus && selectedOption) {
      setIsAddQuiz(true);
      setFormValue({});
      setIsUpdate(false);
      setIsLoading(false);
      setDescriptionData("");
    } else {
      toast.error("Please select language");
    }
  };

  const handleDeleteView = (id, index) => {
    setIsDelete(true);
    setQuizId(id);
    setIsIndex(index);
    setIsLoading(false);
  };

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const getCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        img ? img : IMG_URL + newImge.category_image,
        croppedAreaPixels
      );
      console.log("Cropped Image: ", croppedImage);
    } catch (e) {
      console.error("Crop failed:", e);
    }
  }, [croppedAreaPixels, img, IMG_URL, newImge]);

  const getCroppedImg = (imageSrc, croppedAreaPixels) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = imageSrc;
      image.setAttribute("crossOrigin", "anonymous");

      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = croppedAreaPixels.width;
        canvas.height = croppedAreaPixels.height;

        ctx.drawImage(
          image,
          croppedAreaPixels.x,
          croppedAreaPixels.y,
          croppedAreaPixels.width,
          croppedAreaPixels.height,
          0,
          0,
          croppedAreaPixels.width,
          croppedAreaPixels.height
        );

        const base64Image = canvas.toDataURL("image/jpeg");
        setImg(base64Image);

        fetch(base64Image)
          .then((res) => res.blob())
          .then((blob) => {
            const file = new File([blob], "cropped-image.jpg", {
              type: "image/jpeg",
            });
            setImage(file);
          });
      };

      image.onerror = (error) => {
        reject(error);
      };
    });
  };

  const calculateSize = (html) => {
    const blob = new Blob([html], { type: "text/html" });
    const sizeInBytes = blob.size;
    const sizeInMB = sizeInBytes / (1024 * 1024);

    console.log("sizeInMB ???", sizeInMB);

    // setSizeInMB(sizeInMB);
  };

  return (
    <div className="md:m-4 m-1 fontNew">
      <div className="flex sm:flex-nowrap flex-wrap justify-end mb-7">
        <div className="flex sm:flex-nowrap flex-wrap-reverse items-center justify-end sm:w-auto w-full">
          <div>
            <button
              onClick={handleAdd}
              className="bg-[#e29c29] text-white flex items-center py-2 px-3 sm:mb-0 mb-3 rounded-lg whitespace-nowrap"
            >
              <img src={add} className="w-6 mr-2" alt="" />
              Add Quiz
            </button>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-6 mb-5">
        <div className="md:col-span-4 col-span-12">
          <Select
            value={selectedOption}
            onChange={(option) => {
              setSelectedOption(option);
              setSelectedOptions(null);
              setSelectStatus(null);
              setQuizData([]);
              setPageNo(1);
            }}
            options={categoryData?.map((item) => ({
              label: (
                <div className="flex items-center p-1 uppercase">
                  <img
                    src={
                      item.category_image
                        ? IMG_URL + item.category_image
                        : noImage
                    }
                    className="w-14 h-14 rounded-md object-cover mr-2"
                  />
                  {item.category_name || ""}
                </div>
              ),
              value: item.id,
              id: item.category_name,
            }))}
            placeholder="Select Category"
            className="bg-white py-2 outline-0 rounded-lg"
            styles={customStyles}
          />
        </div>
        <div className="md:col-span-4 col-span-12">
          <Select
            value={selectStatus}
            onChange={(option) => {
              setSelectStatus(option);
              setSelectedOptions(null);
              setQuizData([]);
              setPageNo(1);
            }}
            options={listLanguages?.map((item) => ({
              label: (
                <div className="flex items-center p-1 uppercase">
                  {item.Language_name || ""}
                </div>
              ),
              value: item.id,
              id: item.Language_name,
            }))}
            placeholder="Select Language"
            className="bg-white py-2 outline-0 rounded-lg"
            styles={customStyles}
          />
        </div>
        <div className="md:col-span-4 col-span-12">
          <Select
            value={selectedOptions}
            onChange={(option) => {
              setSelectedOptions(option);
            }}
            options={subCategoryData?.map((item) => ({
              label: (
                <div className="flex items-center p-1">{item.title || ""}</div>
              ),
              value: `${item.title} ${item.id}`,
              id: item.id,
            }))}
            placeholder="Select Sub Category"
            className="bg-white py-2 outline-0 rounded-lg"
            styles={customStyles}
          />
        </div>
      </div>

      <div className="grid grid-cols-12">
        {loader ? (
          <div className="flex justify-center items-center col-span-12 h-[70vh]">
            <Bars
              height="35"
              width="35"
              color="#e29c29"
              ariaLabel="bars-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
          </div>
        ) : (
          <>
            {quizData.length === 0 ? (
              <div className="col-span-12 h-[50vh] justify-center flex items-center">
                <img src={nodata} className="w-28" alt="No data" />
              </div>
            ) : (
              <>
                <div className="col-span-12">
                  <div
                    className="w-full lg:overflow-hidden overflow-auto"
                    onMouseDown={startDragging}
                    onMouseLeave={stopDragging}
                    onMouseUp={stopDragging}
                    onMouseMove={onDragging}
                    ref={scrollRef}
                  >
                    <table className="w-full border-separate border-spacing-y-3">
                      <thead>
                        <tr className="bg-white">
                          <th className="py-4 px-7 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                            <h4>QUIZ ID</h4>
                          </th>
                          <th className="py-4 px-5 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                            <h4>IMAGE</h4>
                          </th>
                          <th className="py-4 px-2 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                            <h4>TITLE</h4>
                          </th>
                          <th className="py-4 px-2 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                            <h4>SUB TITLE</h4>
                          </th>
                          <th className="py-4 px-2 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                            <h4>DESCRIPTION</h4>
                          </th>
                          <th className="py-4 px-2 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                            <div className="text-center">
                              <h4>ACTION</h4>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {quizData.map((item, index) => {
                          return (
                            <tr key={index} className="font-medium bg-white">
                              <td className="text-start px-7 py-3 first:rounded-l-lg last:rounded-r-lg">
                                <div className="whitespace-nowrap">
                                  {item.id}
                                </div>
                              </td>
                              <td className="text-start lg:px-2 px-4 py-3 first:rounded-l-lg last:rounded-r-lg">
                                <div className="lg:whitespace-normal whitespace-nowrap lg:w-auto ps-3 sm:w-52 w-24 flex items-center">
                                  {item.thumbnail == null ? (
                                    <img
                                      src={
                                        item.quiz_image
                                          ? IMG_URL + item.quiz_image
                                          : user
                                      }
                                      className="w-10 h-10 rounded-md object-cover"
                                      alt=""
                                    />
                                  ) : (
                                    <img
                                      src={
                                        item.thumbnail
                                          ? IMG_URL + item.thumbnail
                                          : user
                                      }
                                      className="w-10 h-10 rounded-md object-cover"
                                      alt=""
                                    />
                                  )}
                                </div>
                              </td>
                              <td className="text-start lg:px-2 px-4 py-3 first:rounded-l-lg last:rounded-r-lg">
                                <div className="whitespace-nowrap">
                                  <p className="text-base truncate w-[250px]">
                                    {item.title || ""}
                                  </p>
                                </div>
                              </td>
                              <td className="text-start lg:px-2 px-4 py-3 first:rounded-l-lg last:rounded-r-lg">
                                <div className="whitespace-nowrap">
                                  <p className="text-base truncate w-[250px]">
                                    {item.sub_title || ""}
                                  </p>
                                </div>
                              </td>
                              <td className="text-start lg:px-2 px-4 py-3 first:rounded-l-lg last:rounded-r-lg">
                                <div className="whitespace-nowrap">
                                  <p className="text-base truncate w-[300px] h-[45px]">
                                    <HtmlContent
                                      htmlString={item.description || ""}
                                    />
                                  </p>
                                </div>
                              </td>
                              <td className="text-start flex justify-center lg:px-2 px-4 py-3 first:rounded-l-lg last:rounded-r-lg">
                                <div className="flex items-center w-[300px] justify-center">
                                  <div
                                    onClick={() => handleView(item)}
                                    className="cursor-pointer"
                                  >
                                    <img
                                      src={view}
                                      className="lg:w-9 w-8"
                                      alt="View"
                                    />
                                  </div>
                                  <div
                                    onClick={() =>
                                      handleDeleteView(item.id, index)
                                    }
                                    className="ml-4 cursor-pointer"
                                  >
                                    <img
                                      src={deletes}
                                      className="lg:w-9 w-8"
                                      alt="Delete"
                                    />
                                  </div>
                                  <div
                                    className="ml-4 cursor-pointer"
                                    onClick={() => handleEdit(item)}
                                  >
                                    <img
                                      src={edit}
                                      className="lg:w-9 w-8"
                                      alt="Delete"
                                    />
                                  </div>
                                  <div
                                    className="ml-4 cursor-pointer bg-[#6B71FF20] p-2 rounded-full whitespace-nowrap flex items-center text-[#6B71FF]"
                                    onClick={() => handleDetails(item)}
                                  >
                                    <CirclePlus
                                      color="#6B71FF"
                                      className="mr-1"
                                      size={19}
                                    />{" "}
                                    Add Question
                                  </div>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="col-span-12 flex flex-wrap items-center sm:justify-end justify-center bg-white py-4 sm:px-8 px-0 rounded-lg">
                  <div className="flex items-center cursor-pointer">
                    <p
                      onClick={() => handlePageChange(pageNo - 1)}
                      disabled={pageNo === 1}
                    >
                      Previous
                    </p>
                    <div className="flex items-center mx-6">
                      {renderPaginationButtonss()}
                    </div>
                    <p
                      onClick={() => handlePageChange(pageNo + 1)}
                      disabled={pageNo === totalPage}
                    >
                      Next
                    </p>
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>

      <Dialog open={isAddQuiz} onClose={() => setIsAddQuiz(false)} size="xl">
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="p-4 sm:w-auto w-[330px] md:h-[700px] h-[500px] overflow-auto fontNew">
              <h4 className="text-lg font-semibold mb-2">
                {isUpdate ? "Update" : "Add"} Quiz
              </h4>
              <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-12 ">
                  <div className="col-span-12 flex items-center mx-2 my-2">
                    <div className="w-full p-5 border-2 border-dashed rounded-md shadow-sm border-slate-300/60 dark:border-darkmode-400">
                      <div className="relative h-52 w-full image-fit flex justify-center items-start">
                        {img || formValue.quiz_image ? (
                          <>
                            {imageType == 1 ? (
                              <>
                                <img
                                  className="rounded-md h-52"
                                  alt="Midone - HTML Admin Template"
                                  src={
                                    img
                                      ? img
                                      : formValue.quiz_image
                                      ? IMG_URL + formValue.quiz_image
                                      : noImage
                                  }
                                />
                                {img ? (
                                  <div
                                    className="w-6 h-6"
                                    onClick={() => setImg("")}
                                  >
                                    <img
                                      src={close}
                                      className="w-6 h-6 -ms-4 -mt-2 relative"
                                      alt=""
                                    />
                                  </div>
                                ) : (
                                  ""
                                )}
                              </>
                            ) : (
                              <>
                                <video
                                  className="rounded-md h-52"
                                  controls
                                  src={
                                    img
                                      ? img
                                      : formValue.quiz_image
                                      ? IMG_URL + formValue.quiz_image
                                      : noImage
                                  }
                                ></video>
                                {img ? (
                                  <div
                                    className="w-6 h-6"
                                    onClick={() => setImg("")}
                                  >
                                    <img
                                      src={close}
                                      className="w-6 h-6 -ms-4 -mt-2 relative"
                                      alt=""
                                    />
                                  </div>
                                ) : (
                                  ""
                                )}
                              </>
                            )}
                          </>
                        ) : (
                          <p className="flex justify-center items-center h-52">
                            Data Not Found{" "}
                          </p>
                        )}
                      </div>
                      <div className="flex justify-center items-center mt-4">
                        <div className="relative flex items-center justify-center cursor-pointer">
                          <Upload className="text-blue-600" size={18} />
                          <h4 className="mr-1 text-blue-600 ml-2 sm:text-base text-sm">
                            Upload Quiz Image/Video
                          </h4>{" "}
                          <input
                            id="horizontal-form-1"
                            type="file"
                            className="absolute top-0 left-0 w-full cursor-pointer h-full opacity-0"
                            onChange={handleFile}
                          />
                        </div>
                        <div>
                          {img && !cropImg ? (
                            <>
                              {imageType == 2 ? (
                                ""
                              ) : (
                                <>
                                  <b
                                    className="cursor-pointer underline sm:text-base text-sm"
                                    onClick={(e) => setCropModal(true)}
                                  >
                                    Crop Image
                                  </b>
                                </>
                              )}
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-2">
                    <h4 className="text-sm font-medium mb-3">
                      Select Subcategory
                    </h4>
                    <select
                      name="sub_category_id"
                      id=""
                      value={formValue.sub_category_id || ""}
                      onChange={handleChange}
                      required
                      className="select-arrow-hidden w-full outline-[#e1c595] border-2 px-4 py-3 rounded-md"
                    >
                      <option label="Select Subcategory"></option>
                      {subCategoryData.map((item, index) => {
                        return (
                          <option key={index} value={item.id}>
                            {item.title}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  {languageName ? (
                    <div className="col-span-12 md:mx-2 mx-0 my-2">
                      <h4 className="text-sm font-medium mb-3">Language</h4>
                      <input
                        type="text"
                        name="title"
                        value={languageName || ""}
                        className="border-2 px-4 py-3 rounded-md w-full outline-[#e1c595]"
                        placeholder="Enter"
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="col-span-12 md:mx-2 mx-0 my-2">
                    <h4 className="text-sm font-medium mb-3">Quiz Title</h4>
                    <input
                      type="text"
                      name="title"
                      value={formValue.title || ""}
                      onChange={handleChange}
                      required
                      className="border-2 px-4 py-3 rounded-md w-full outline-[#e1c595]"
                      placeholder="Enter"
                    />
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-2">
                    <h4 className="text-sm font-medium mb-3">Quiz Subtitle</h4>
                    <input
                      type="text"
                      name="sub_title"
                      value={formValue.sub_title || ""}
                      onChange={handleChange}
                      required
                      className="border-2 px-4 py-3 rounded-md w-full outline-[#e1c595]"
                      placeholder="Enter"
                    />
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-2">
                    <h4 className="text-sm font-medium mb-3">Reward Point</h4>
                    <input
                      type="number"
                      name="reward_point"
                      value={formValue.reward_point || ""}
                      onChange={handleChange}
                      required
                      min={0}
                      className="border-2 px-4 py-3 rounded-md w-full outline-[#e1c595]"
                      placeholder="Enter"
                    />
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-2">
                    <h4 className="text-sm font-medium mb-3">
                      Quiz Description
                    </h4>
                    <SunEditor
                      setContents={descriptionData || ""}
                      //   onChange={setDescriptionData}
                      onChange={(content) => {
                        setDescriptionData(content);
                        calculateSize(content);
                      }}
                      height="280px"
                      setOptions={{
                        buttonList: [
                          ["undo", "redo"],
                          ["fontSize"],
                          ["bold", "underline", "italic"],
                          ["fontColor", "hiliteColor"],
                          ["align", "list"],
                          ["link", "image"],
                        ],
                      }}
                      name="my-editor"
                      required
                    />
                  </div>
                </div>
                <div className="mt-6 flex justify-end">
                  <button
                    type="button"
                    onClick={() => setIsAddQuiz(false)}
                    className="bg-[#EF5F5F] py-2 px-7 text-white rounded-lg mr-5"
                  >
                    Close
                  </button>
                  <button
                    type="submit"
                    disabled={isLoading}
                    className="bg-[#00987C] text-white h-[45px] w-30 rounded-lg"
                  >
                    {isLoading ? (
                      <div className="flex justify-center">
                        <Circles
                          width={25}
                          height={25}
                          color="#fff"
                          ariaLabel="circles-loading"
                          wrapperStyle={{}}
                          visible={true}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      `${isUpdate ? "Update" : "Add"}`
                    )}
                  </button>
                </div>
              </form>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog
        open={isModalOpens}
        onClose={() => setModalOpens(false)}
        size="xl"
      >
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white fontNew">
            <div className="p-5 sm:w-auto w-[330px] md:h-[700px] h-[500px] overflow-auto">
              <div className="mb-4 flex justify-between">
                <h4 className="text-lg font-medium">Quiz Details</h4>
                <CircleX
                  color="gray"
                  size={28}
                  onClick={() => setModalOpens(false)}
                  className="cursor-pointer"
                />
              </div>
              <div className="flex justify-center mt-4">
                {formValue.thumbnail == null ? (
                  <img
                    src={
                      formValue.quiz_image
                        ? IMG_URL + formValue.quiz_image
                        : noImage
                    }
                    className="w-auto h-52 object-cover"
                    alt=""
                  />
                ) : (
                  <video
                    controls
                    src={
                      formValue.quiz_image
                        ? IMG_URL + formValue.quiz_image
                        : noImage
                    }
                    className="w-auto h-52 object-cover"
                  ></video>
                )}
              </div>
              <div className="mt-3">
                <h4>Title :</h4>
                <h3 className="text-xl break-word font-medium">
                  {formValue.title || ""}
                </h3>
              </div>
              <div className="my-3">
                <h4>Sub Title :</h4>
                <h3 className="text-lg break-word font-medium">
                  {formValue.sub_title || ""}
                </h3>
              </div>
              <div className="my-3 flex items-center">
                <h4>Reward Point :</h4>{" "}
                <h3 className="text-lg break-word font-medium">
                  {formValue.reward_point || ""}
                </h3>
              </div>
              <div>
                <h4>Description :</h4>
                <p>
                  <HtmlContent htmlString={formValue.description || ""} />
                </p>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog open={isDelete} onClose={() => setIsDelete(false)} size="2xl">
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="flex justify-center text-center my-4 sm:px-16 px-4 fontNew">
              <div>
                <h4 className="text-xl font-semibold text-black mt-6">
                  Delete Quiz?
                </h4>
                <p className="text-sm text-gray-500 my-3">
                  Are you sure you want to delete this Quiz?
                </p>
                <div className="mt-13 flex items-center mb-5">
                  <button
                    className="bg-[#F4F5FA] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2"
                    onClick={() => setIsDelete(false)}
                  >
                    Close
                  </button>
                  <button
                    disabled={isLoading}
                    className="bg-[#e29c29] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2 text-white"
                    onClick={handleDelete}
                  >
                    {isLoading ? (
                      <div className="flex justify-center">
                        <Circles
                          width={25}
                          height={25}
                          color="#fff"
                          ariaLabel="circles-loading"
                          wrapperStyle={{}}
                          visible={true}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      "Yes, Delete"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog
        open={cropModal}
        onClose={() => setCropModal(false)}
        initialFocus={imageRef}
        size="lg"
      >
        <Dialog.Panel className=" w-full mx-auto bg-white px-5 pt-2">
          <Dialog.Title className="flex justify-between text-lg font-medium">
            <h4>Crop Image</h4>
            <CircleX
              color="gray"
              size={28}
              onClick={() => setCropModal(false)}
              className="cursor-pointer"
            />
          </Dialog.Title>
          <Dialog.Description className="mt-4">
            <div className="relative w-full h-[400px]">
              <Cropper
                image={img ? img : IMG_URL + newImge.category_image}
                crop={crop}
                zoom={zoom}
                aspect={297 / 210}
                onCropChange={setCrop}
                onZoomChange={setZoom}
                onCropComplete={onCropComplete}
              />
            </div>
          </Dialog.Description>
          <Dialog.Footer className="flex justify-end mt-4">
            <button
              className="w-24 bg-[#00987C] px-4 py-2 rounded-lg text-white"
              type="button"
              onClick={() => {
                getCroppedImage();
                setCropModal(false);
              }}
            >
              Submit
            </button>
          </Dialog.Footer>
        </Dialog.Panel>
      </Dialog>
    </div>
  );
}

export default Quiz;
